import React, {useContext} from 'react';
import styles from './create-folder-header.styles.css';
import {CprButtonIcon} from 'canopy-styleguide!sofe';
import SaveToCanopyFilesDropdownContext from 'src/documents/save-to-canopy-files-dropdown/save-to-canopy-files-dropdown.context';

export default function CreateFolderHeader(props) {
  const dispatch = useContext(SaveToCanopyFilesDropdownContext);

  return (
    <div className={styles.header}>
      <div className={styles.left}>
        <span className={styles.title}>
          Name folder
        </span>
      </div>
      <div className={styles.right}>
        <CprButtonIcon
          icon="close-small"
          ariaText="Close dropdown"
          onClick={() => dispatch({type: 'close_dropdown'})}
        />
      </div>
    </div>
  )
}